import preparedReducer from './reducer';
import { requestPDFEntityReports, requestPDFReports } from './actions';

export const reducer = preparedReducer;

export const SLICE_NAME = 'pdfReports';

export const selectors = (state) => state[SLICE_NAME];

export const actions = {
  requestPDFReports,
  requestPDFEntityReports,
};
